import React from 'react';
import { cn } from '../cn';
import { Typography } from '../Typography/Typography';
import { Button } from '../Button/Button';
import { Grid, GridItem } from '../Grid/Grid';

export type ContentBlockProps = React.PropsWithChildren<{
  title: string,
  titleTo?: string,
  highlight?: string,
  text?: string | React.ReactNode,
  addOn?: JSX.Element,
  className?: string,
  highlightClassName?: string,
  textClassName?: string;
  size?: 'sm' | 'md' | 'lg',
  align?: 'start' | 'center' | 'end',
  dangerouslySetTextInnerHTML?: {__html: string},
  type?: 'narrow' | 'extended' | 'wide' | 'basic' | 'full',
  titleTag?: 'span' | 'h1',
}>;

export const ContentBlock = (passedProps: ContentBlockProps): JSX.Element => {
  const props = Object.assign({size: 'md'}, passedProps);
  const textSizeMap: {[key: string]: "sm" | "md" | "lg" | "xl" | "xs" | undefined} = {
    'sm': 'sm',
    'md': 'md',
    'lg': 'lg',
  };
  const headerSizeMap: {[key: string]: "sm" | "md" | "lg" | "xl" | "xs" | undefined} = {
    'sm': 'sm',
    'md': 'md',
    'lg': 'lg',
  };
  const alignTextMap: {[key: string]: 'text-left' | 'text-center' | 'text-right'} = {
    'start': 'text-left',
    'center': 'text-center',
    'end': 'text-right',
  }

  return (
    <section className = {cn('flex flex-col gap-8', alignTextMap[props.align || 'center'], props.className)}>
      <div className='flex flex-col gap-1'>
        <Typography className={cn('text-primary-hover text-base', props.highlightClassName)} weight='bold' align={props.align || 'center'}>{props.highlight}</Typography>
        <Typography tag={props.titleTag || 'span'} display size={headerSizeMap[props.size]} weight='bold' align={props.align || 'center'}>
          {props.titleTo && <Button unstyled to={props.titleTo}>{props.title}</Button> || props.title}
        </Typography>
        <Grid className='mt-0'>
          <GridItem type={props.type || 'narrow'}>
            <Typography className={cn('m-auto', props.textClassName)} size={textSizeMap[props.size]} align={props.align || 'center'} dangerouslySetInnerHTML={props.dangerouslySetTextInnerHTML}>{props.text}</Typography>
          </GridItem>
        </Grid>
      </div>
      {props.addOn && (
        <div className='flex flex-col'>{props.addOn}</div>
      )}
    </section>
  );
};